import React from "react";
import data from "../../json/Allservices/Technology.json";
import { ReactComponent as Icon1 } from "../../../src/Icons/Tech1.svg";
import { ReactComponent as Icon2 } from "../../../src/Icons/Tech2.svg";
import { ReactComponent as Icon3 } from "../../../src/Icons/Tech3.svg";
import { ReactComponent as Icon4 } from "../../../src/Icons/Tech4.svg";

const Section2 = () => {
  const icons = [Icon1, Icon3, Icon2, Icon4];
  return (
    <div className="w-full flex justify-center relative tech-after pb-20 lg:pb-[120px]">
      <div className="2xl:container w-full px-6 pt-10 md:px-10 lg:px-20  lg:px-20 flex flex-col ">
        <section className="w-full flex flex-col items-center ">
          <div className="flex flex-col gap-3 sm:gap-4 lg:text-left text-center items-center w-full lg:w-[70%]">
            <h1 className="text-24 sm:text-36 lg:text-48 text-center font-semibold text-primarycolor w-full">
              {data.section1.title}
            </h1>
            <p className="text-14 sm:text-16 md:text-18 text-center text-secondaryblack ">
              {data.section1.desc2}
            </p>
          </div>
        </section>
        <section className="w-full  flex mt-6 sm:mt-12 lg:mt-16 ">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 sm:gap-y-6  relative">
            {data.section1.list.map((ele, i) => {
              let Icon = icons[i];
              return (
                <div className=" p-6 w-full  h-full rounded-[16px] sm:rounded-[24px] border-[1px] border-[services] group serviceparent  shadow-services">
                  <div className="flex items-center flex-col gap-4 ">
                    <Icon className="max-md:hidden serviceicon servicechild max-md:w-12 max-md:h-12" />
                    <div className="lg:text-center space-y-4 servicedetails">
                      <div className="flex items-center w-full gap-4">
                      <Icon className="md:hidden serviceicon servicechild max-w-12 max-h-12 min-w-12 min-h-12" />

                      <h1 className="text-16 sm:text-18 sm:w-full md:text-20 font-semibold servicechild">
                        {ele.heading}
                      </h1>
                      </div>
                      <p className="text-14 md:text-16 text-approachblk servicechild sm:pb-3">
                        {ele.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Section2;
